// extracted by mini-css-extract-plugin
export default {"iapTYText":"n3QmS_jU","iapTYContent":"_3QCXkQou"};